<template>
  <div class="form-group has-float-label m-0">
    <b-input
      class="form-control"
      :id="inputId"
      :size="size"
      placeholder=" "
      :type="inputType"
      :name="name"
      :class="cssClass"
      :value="value"
      :readonly="readonly"
      @input="(e) => $emit('input', e)"
    />
    <label :for="inputId">{{ lableText }}</label>
  </div>
</template>
<script>
export default {
  name: "input",
  data() {
    return {
      context: null,
    };
  },
  props: {
    inputType: {
      type: String,
      required: false,
      default: "text",
    },
    name: {
      type: String,
      required: false,
      default: "textbox",
    },
    cssClass: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    lableText: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
    inputId: {
      type: String,
      required: false,
      default: `${Date.now()}`,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: "lg",
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/bootstrap-float-label.css";
b-input::-webkit-outer-spin-button,
b-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.form-control {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: Nunito;
  height: 39px !important;
  border: 1.5px solid #dee2e6;
}

.form-control:focus {
  border-color: #030303;
}

.form-control-lg {
  font-size: 130%;
}

.a {
  display: block;
  padding: 10px;
  position: absolute;
  z-index: -1;
  top: 1rem;
  left: 100%;
  margin-left: -62px;
  transition: all 0.2s;
}

a:hover {
  margin-left: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
